var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('iq-card', {
    attrs: {
      "body-class": "p-0"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        return [_c('div', {
          staticClass: "iq-edit-list"
        }, [_c('tab-nav', {
          staticClass: "iq-edit-profile d-flex",
          attrs: {
            "pills": true
          }
        }, [_c('tab-nav-items', {
          staticClass: "col-md-4 p-0",
          attrs: {
            "active": true,
            "title": "REQUEST & PROGRESS"
          },
          on: {
            "click": function click($event) {
              ;
              _vm.selectedTab = 'progress', _vm.fetchData();
            }
          }
        }), _c('tab-nav-items', {
          staticClass: "col-md-4 p-0",
          attrs: {
            "active": false,
            "title": "FINISH REPAIR & MAINTENANCE"
          },
          on: {
            "click": function click($event) {
              ;
              _vm.selectedTab = 'finish', _vm.fetchData();
            }
          }
        }), _c('tab-nav-items', {
          staticClass: "col-md-4 p-0",
          attrs: {
            "active": false,
            "title": "REPORT REPAIR & MAINTENANCE"
          },
          on: {
            "click": function click($event) {
              _vm.selectedTab = 'report';
            }
          }
        })], 1)], 1)];
      },
      proxy: true
    }])
  })], 1), _vm.selectedTab == 'report' ? _c('b-col', {
    attrs: {
      "col": "12"
    }
  }, [_c('NewTabReport', {
    attrs: {
      "fleetOptions": _vm.optionsFleets,
      "fleetTypeOptions": _vm.optionsVehicleType,
      "statusOptions": _vm.statusOptions,
      "defaultParams": _vm.params
    }
  })], 1) : _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v(" SERVICE & REPAIR")])])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_vm.selectedTab == 'progress' && _vm.getSrAcces('add') ? _c('b-button', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function click($event) {
              _vm.showModalFleets = true;
            }
          }
        }, [_vm._v("Create Data")]) : _vm._e()];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('div', {
          staticClass: "w-100"
        }, [_c('b-row', [_c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('div', {
          staticClass: "d-flex justify-content-end"
        })]), _c('b-col', {
          staticClass: "my-3",
          attrs: {
            "md": "12"
          }
        }, [_c('SrFiltersTemplate', {
          attrs: {
            "statusOptions": _vm.statusOptions,
            "optionsFleets": _vm.optionsFleets,
            "optionsVehicleType": _vm.optionsVehicleType,
            "params": _vm.params
          },
          on: {
            "onFilter": _vm.fetchData
          },
          model: {
            value: _vm.params,
            callback: function callback($$v) {
              _vm.params = $$v;
            },
            expression: "params"
          }
        })], 1), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('table', {
          staticClass: "w-100 table-striped"
        }, [_c('thead', [_c('th', [_vm._v("Vessel Name")]), _c('th', [_vm._v("Loaction")]), _c('th', [_vm._v("Accident Date")]), _vm.selectedTab == 'finish' ? _c('th', [_vm._v("Actual Finish Date")]) : _vm._e(), _vm.selectedTab == 'finish' ? _c('th', [_vm._v("Total Days")]) : _vm._e(), _c('th', [_vm._v("Total Item Repair")]), _vm.selectedTab == 'progress' ? _c('th', [_vm._v("Est. Cost Service & Repair")]) : _vm._e(), _c('th', [_vm._v("Pic")]), _vm.selectedTab == 'progress' ? _c('th', [_vm._v("Status")]) : _vm._e(), _vm.selectedTab == 'progress' ? _c('th', [_vm._v("Work Location")]) : _vm._e(), _c('th', [_vm._v("Action")])]), !_vm.loading ? _c('tbody', [_vm.listServiceRepair.length ? _vm._l(_vm.listServiceRepair, function (item, index) {
          var _item$cost_est, _item$site;
          return _c('tr', {
            key: index
          }, [_c('td', [_vm.selectedTab != 'finish' ? _c('b-badge', {
            attrs: {
              "variant": "success"
            }
          }, [_vm._v(_vm._s(item.fleet))]) : _c('b-badge', {
            attrs: {
              "variant": "success"
            }
          }, [_vm._v(_vm._s(item.vehicle.name))])], 1), _c('td', [_vm._v(_vm._s(item.location))]), _c('td', [_vm._v(_vm._s(_vm.toFormatDate(item.accident_at)))]), _vm.selectedTab == 'finish' ? _c('td', [_vm._v(_vm._s(item !== null && item !== void 0 && item.finish_date_real ? _vm.toFormatDate(item === null || item === void 0 ? void 0 : item.finish_date_real) : '-'))]) : _vm._e(), _vm.selectedTab == 'finish' ? _c('td', [item.start_date_est && item.finish_date_real ? [_vm._v(" " + _vm._s(_vm.totalDays(item.start_date_est, item.finish_date_real)) + " Days ")] : [_vm._v("-")]], 2) : _vm._e(), _c('td', [_vm._v(_vm._s(item.total_repair) + " Repair")]), _vm.selectedTab == 'progress' ? _c('td', [_vm._v(_vm._s(_vm.formatCurrency((_item$cost_est = item.cost_est) !== null && _item$cost_est !== void 0 ? _item$cost_est : 0)))]) : _vm._e(), _c('td', {
            staticClass: "d-flex flex-column"
          }, [_c('p', {
            staticClass: "mb-0"
          }, [_vm._v(_vm._s(item.pic))])]), _vm.selectedTab == 'progress' ? _c('td', [_c('b-badge', {
            attrs: {
              "variant": "".concat((item === null || item === void 0 ? void 0 : item.status) === 'new' ? 'info' : item.status === 'review' ? 'primary' : item.status === 'approved' ? 'success' : item.status === 'progress' ? 'warning' : 'danger', " d-block")
            }
          }, [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : item.status))])], 1) : _vm._e(), _vm.selectedTab == 'progress' ? _c('td', [_vm._v(_vm._s((_item$site = item.site) !== null && _item$site !== void 0 ? _item$site : '-'))]) : _vm._e(), _c('td', [_c('b-dropdown', {
            attrs: {
              "text": "Action",
              "size": "sm",
              "variant": "outline-primary"
            }
          }, [item.status == 'review' && _vm.getSrAcces('approval') ? _c('b-dropdown-item', {
            on: {
              "click": function click() {
                return _vm.handleAction(item, 'approve');
              }
            }
          }, [_vm._v("Approve Service & Repair")]) : _vm._e(), item.status == 'new' && _vm.getSrAcces('update') ? _c('b-dropdown-item', {
            on: {
              "click": function click() {
                return _vm.handleAction(item, 'review');
              }
            }
          }, [_vm._v("Review Service & Repair")]) : _vm._e(), _c('b-dropdown-item', {
            on: {
              "click": function click() {
                return _vm.handleAction(item, 'detail');
              }
            }
          }, [_vm._v("Detail Service & Repair")]), _vm.selectedTab == 'finish' ? _c('b-dropdown-item', {
            on: {
              "click": function click() {
                return _vm.handleAction(item, 'history');
              }
            }
          }, [_vm._v("History Service & Repair")]) : _vm._e(), _vm.selectedTab == 'finish' && !(item !== null && item !== void 0 && item.finish_date_real) && !(item !== null && item !== void 0 && item.start_date_real) && _vm.getSrAcces('update') ? _c('b-dropdown-item', {
            on: {
              "click": function click() {
                return _vm.handleAction(item, 'finish');
              }
            }
          }, [_vm._v("Set Realization Service & Repair")]) : _vm._e(), _vm.selectedTab == 'progress' && !_vm.permissionDelete(item === null || item === void 0 ? void 0 : item.request_delete) ? _c('b-dropdown-item', {
            on: {
              "click": function click() {
                return _vm.onRequestDeleteServiceRepair(item);
              }
            }
          }, [_vm._v("Request Delete Service & Repair")]) : _vm._e(), _vm.selectedTab == 'progress' && _vm.permissionDelete(item === null || item === void 0 ? void 0 : item.request_delete) ? _c('b-dropdown-item', {
            on: {
              "click": function click() {
                return _vm.deleteServiceRepair(item);
              }
            }
          }, [_vm._v("Delete Service & Repair")]) : _vm._e(), _c('b-dropdown-item', {
            on: {
              "click": function click($event) {
                ;
                _vm.showSidebar = true, _vm.selectedItem = item;
              }
            }
          }, [_vm._v("Log History")])], 1)], 1)]);
        }) : [_c('tr', [_c('td', {
          staticClass: "p-2",
          attrs: {
            "colspan": "9"
          }
        }, [_vm._v(" No Data Service & Repair ")])])]], 2) : _vm._e()]), _vm.loading ? _c('div', {
          staticClass: "w-100 d-flex justify-content-center py-5"
        }, [_c('b-spinner')], 1) : _vm._e()])], 1), _c('div', {
          staticClass: "mt-4 d-flex align-items-center w-100 justify-content-end"
        }, [_c('b-pagination', {
          staticClass: "mb-0 mr-3",
          attrs: {
            "total-rows": _vm.meta.totalItems,
            "per-page": _vm.meta.perPage,
            "first-number": "",
            "align": "center"
          },
          on: {
            "change": function change(page) {
              _vm.meta.page = page;
            }
          },
          model: {
            value: _vm.meta.page,
            callback: function callback($$v) {
              _vm.$set(_vm.meta, "page", $$v);
            },
            expression: "meta.page"
          }
        }), _c('b-form-select', {
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "plain": "",
            "options": _vm.limitOptions
          },
          on: {
            "input": _vm.fetchData
          },
          model: {
            value: _vm.meta.perPage,
            callback: function callback($$v) {
              _vm.$set(_vm.meta, "perPage", $$v);
            },
            expression: "meta.perPage"
          }
        })], 1)], 1)];
      },
      proxy: true
    }])
  })], 1), _c('modal-fleets', {
    attrs: {
      "isOpen": _vm.showModalFleets
    },
    on: {
      "close": function close($event) {
        _vm.showModalFleets = false;
      },
      "next": function next(vehicleId) {
        return _vm.$router.push('/sr/service-repair-form?vehicleId=' + vehicleId);
      }
    }
  }), _c('b-sidebar', {
    attrs: {
      "title": "Log History Service & Repair",
      "right": "",
      "width": "540px",
      "bg-variant": "white",
      "shadow": "",
      "backdrop": ""
    },
    model: {
      value: _vm.showSidebar,
      callback: function callback($$v) {
        _vm.showSidebar = $$v;
      },
      expression: "showSidebar"
    }
  }, [_vm.showSidebar ? [_c('LogsHistoryItemSR', {
    attrs: {
      "selectedItem": _vm.selectedItem,
      "defaultParams": _vm.defaultParams
    }
  })] : _vm._e()], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }